/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Assessment } from './Assessment'
import type { AssessmentResult } from './AssessmentResult'
import type { Company } from './Company'
import type { Professional } from './Professional'
import type { UploadFile } from './UploadFile'
import type { Users_Permissions_User } from './Users_Permissions_User'
export type Candidate = {
  id?: number
  email: string
  assessments?: Array<Assessment>
  firstName?: string
  professional?: Professional
  company?: Company
  username?: string
  lastName?: string
  avatar?: UploadFile
  externalId?: string
  assessmentResults?: Array<AssessmentResult>
  language?: Candidate.language
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Candidate {
  export enum language {
    EN = 'en',
    NL = 'nl',
  }
}
